import { render, staticRenderFns } from "./TransactionSummary.vue?vue&type=template&id=74a41f8a&scoped=true&"
import script from "./TransactionSummary.vue?vue&type=script&lang=ts&"
export * from "./TransactionSummary.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionSummary.vue?vue&type=style&index=0&id=74a41f8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a41f8a",
  null
  
)

export default component.exports